const extractEmails = (text) => {
  return text.match(/([\w+-.%]+@[\w-.]+\.[a-zA-Z0-9_-]+)/gi) || [];
};

export { extractEmails };
